/**
 * Utility functions for working with instance types
 */

/**
 * Checks if the given instance type is a sandbox instance
 * @param instanceType The instance type to check
 * @returns True if the instance type is sandbox, false otherwise
 */
export const isSandboxInstance = instanceType => {
  return (instanceType === null || instanceType === void 0 ? void 0 : instanceType.toLowerCase()) === 'sandbox';
};